// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"766":"8ea66406","787":"ec18fbf8","950":"f0102a8c","966":"9e5cd88c"}[chunkId] + ".chunk.js";
};